import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import store from '../../Redux';
import { doPost, doLoad, doPut, select, doDelete, doDuplicate, apiUrlOpen } from '../../Redux/Actions'

import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '../../Components/Dialog';
import Table from '../../Components/Table';
import Master from '../../Components/Master';
import Filter from '../../Components/Filter';
import { TextFieldHelper, SelectFieldWrapper } from '../../Components/Fields';
import convertMinutesToString from '../../Components/convertMinutesToString';
import Grid from '@material-ui/core/Grid';
import Loader from '../../Components/Loader';

import moment from 'moment'
import 'moment/locale/de'
moment.locale("de");

const styles = theme => ({
    fab: {
       position: 'absolute',
       bottom: theme.spacing.unit * 2,
       right: theme.spacing.unit * 2,
    },
    iconButton: {
        marginRight: "24px",
        top: "50%",
        display: "inline-block",
        position: "relative",
        transform: "translateY(-50%)",
    },
})

const columns = [
    "",
    "Paket",
    "Kürzel",
    "Name",
    "Kommentar",
    "Von",
    "Bis",
    "Start",
    "Ende",
    "Netto",
];

const options = {}

var DialogForm = ({handleChange, data}) => {
    return (
        <div>
            <Grid container spacing={8}>
                <TextFieldHelper n={6} value={data.paket} onChange={handleChange('paket')} label="Paket" />
                <TextFieldHelper n={2} value={data.kuerzel_linie} onChange={handleChange('kuerzel_linie')} label="Linie" />
                <TextFieldHelper n={2} value={data.kuerzel_bus} onChange={handleChange('kuerzel_bus')} label="Bus" />
                <TextFieldHelper n={2} value={data.kuerzel_nummer} onChange={handleChange('kuerzel_nummer')} label="Nummer" />
                <TextFieldHelper n={12} value={data.name} onChange={handleChange('name')} label="Name" />
            </Grid>
        </div>
    )
}

class Umlaufplan extends Master {

    state = {
        umlaufplan: {
            count: 0
        },
        putLoading: {},
        dialogOpen: false,
        newEntry: {

        },
        tableFilter: {

        },
        selectedRows: []
    }

    componentDidMount() {

        document.title = "Umlaufpläne"

        this.props.doLoad(this.state.filter)
        this.props.doFilter()
        this.unsubscribe = store.subscribe(() => {
                var genericData = select(store.getState(), "umlaufplan")
                if(_.has(genericData, "putLoading") && this.state.putLoading !== genericData.putLoading) {
                    this.setState({
                        putLoading: genericData.putLoading
                    })
                }
                if(_.has(genericData, "dialogOpen") && this.state.dialogOpen !== genericData.dialogOpen) {
                    this.setState({
                        dialogOpen: genericData.dialogOpen
                    })
                }
            }
        )
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    handleClickOpen = () => {
        this.setState({
            dialogOpen: this.state.dialogOpen ? false : true
        });
    }

    handleChange = name => event => {
        this.state.newEntry[name] = event.target.value
        this.setState({
            newEntry: this.state.newEntry
        });
    }

    populate = (data) => {
        this.props.doLoad(data)
    }

    deleteAction = (id) => {
        if (window.confirm('Willst du den Eintrag wirklich löschen?')) {
            this.props.doDelete(id)
        }
    }

    postData = () => {
        this.props.doPost(this.state.newEntry)
        this.setState({
            newEntry: {}
        })
    }

    gotoToDetail = (rowIndex, data) => {
        this.props.history.push("umlaufplan/"+this.props.umlaufplan.data[rowIndex].id)
    }

    duplicateAction = (id) => {
        //if (window.confirm('Willst du den Eintrag wirklich löschen?')) {
            this.props.doDuplicate(id)
        //}
    }

    render() {

        var {
            classes, umlaufplan, filter
        } = this.props

        var {
            dialogOpen, isLoading
        } = this.state

        if(isLoading) {
            return (
                <Loader />
            )
        }

        var items = []
        if(_.has(this.props, 'umlaufplan.data') && umlaufplan.data.length > 0) {
            umlaufplan.data.forEach((item) => {
                var name = ""
                if(item.name !== undefined) {
                    name = item.name.split(",")
                }
                var nameFormat = item.name
                if(name.length > 1) {
                    nameFormat = <span><b style={{borderRadius: 3, padding: 2, background: '#eee'}}>{name[0]}</b> {name[1]}</span>
                }
                items.push([
                    item.farbe === undefined ? "" : <div style={{background: item.farbe}} className={classnames("color-block")}></div>,
                    item.paket === undefined ? "-" : item.paket,
                    item.kuerzel === undefined ? "-" : item.kuerzel,
                    item.name === undefined ? "-" : nameFormat,
                    item.intern_name === undefined ? "-" : item.intern_name,
                    item.von === undefined ? "-" : moment(item.von).format('L'),
                    item.bis === undefined ? "-" : moment(item.bis).format('L'),
                    item.start === undefined ? "-" : item.start,
                    item.ende === undefined ? "-" : convertMinutesToString(item.ende_raw, true),
                    item.netto_zeit === undefined ? "-" : convertMinutesToString(item.netto_zeit),
                    item.id
                ])
            })
        }

        return (
            <div>

                <Filter data={filter.data} filter={this.filter} active={this.state.filter} />

                <Table
                    title="Umlaufpläne"
                    key={"items"+items.length}
                    data={items}
                    classes="umlaufplaene"
                    count={umlaufplan === undefined ? 0 : umlaufplan.count}
                    columns={columns}
                    populate={this.populate}
                    onDelete={this.deleteAction}
                    rowClick={this.gotoToDetail}
                    onDuplicate={this.duplicateAction}
                    options={{
                        selectableRows: false,
                        customToolbarSelect: this.customToolbarSelect,
                        onRowsSelect: this.onRowsSelect
                    }}
                />

                <Button variant="fab" className={classes.fab} onClick={this.handleClickOpen} color={"primary"}>
                    <AddIcon />
                </Button>
                <Dialog
                    title="Neuer Umlaufplan"
                    closeAction={this.handleClickOpen}
                    saveAction={this.postData}
                    open={dialogOpen}
                >
                    <DialogForm data={this.state.newEntry} handleChange={this.handleChange} />
                </Dialog>

            </div>
        )

    }

}

const mapStateToProps = state => ({
    umlaufplan: state.umlaufplan,
    filter: state.filter,
})

const mapDispatchToProps = (dispatch, ownProps) => ({

    doFilter: () => dispatch(doLoad("filter", "api/generic/umlaufplan/filter")),

    doDuplicate: (id) => dispatch(doDuplicate("umlaufplan", "api/generic/umlaufplan/duplicate/"+id)),
    doLoad: (filter) => dispatch(doLoad("umlaufplan", "api/generic/umlaufplan/list", filter)),
    doPost: (data) => dispatch(doPost("umlaufplan", "api/generic/umlaufplan", data)),
    doDelete: (id) => dispatch(doDelete("umlaufplan", "api/generic/umlaufplan/"+id, id)),
    doSearch: (filter) => dispatch(doLoad("umlaufplan", "api/generic/umlaufplan/list", filter)),

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(Umlaufplan));



// WEBPACK FOOTER //
// ./src/Routes/Umlaufplaene/index.js